import { Text } from '@chakra-ui/react';

import CoverageConsentModal from './CoverageConsentModal';

interface PhysicalDamageDeclineConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (consentMethod: number) => void;
  isLoading?: boolean;
}

const PhysicalDamageDeclineConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: PhysicalDamageDeclineConfirmationModalProps) => {
  const warningContent = (
    <>
      <Text fontSize="sm" fontWeight="600" mb={2}>
        Physical Damage Coverage protects your vehicle against loss or damage.
      </Text>
      <Text fontSize="sm">
        This includes Collision, Comprehensive, and All Perils coverages. By
        declining all physical damage coverage, the vehicle will not be covered
        for damage from accidents, theft, vandalism, weather events, or other
        perils.
      </Text>
    </>
  );

  return (
    <CoverageConsentModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isLoading}
      title="Physical Damage Coverage Decline"
      warningContent={warningContent}
      attestationText="I have advised my client of the physical damage coverage options and their importance. Client has agreed to decline all physical damage coverage regardless of recommendation."
    />
  );
};

export default PhysicalDamageDeclineConfirmationModal;
